<template>
  <div class="main">
    <div class="navbar_box_fixed" v-show="!isDisplayBigPhoto">
      <div class="navbar_box_width">
        <div class="navbar_box_absolute">
          <!-- <div class="bar_back_btn" @click="goToAlbumHome">返回</div> -->
          <div class="page_title on_bar_center_absolute">照片管理</div>
          <div class="bar_done_btn" @click="goToAlbumHome">完成</div>
        </div>
      </div>
    </div>
    <div class="photo_collection" v-show="!isDisplayBigPhoto" 
      v-infinite-scroll="loadMorePhoto" 
      infinite-scroll-disabled="photoListLoading" 
      infinite-scroll-distance="10"
      infinite-scroll-immediate-check="false">
      <div class="photo_box_width" v-for="(photo, index) in photos" :key="photo.id">
        <div class="photo_box_padding">
          <div class="photo_box_ratio">
            <div class="photo_box_absolute">
                <img class="photo_image" :src="photo.cdnUrlThumb" alt="" @click="showBigPhoto(index)">
                <div class="btn_del" @click="delPhoto(photo.id)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="big_photo" v-if="isDisplayBigPhoto">
      <img :src="photos[currentPhotoIndex].cdnUrl1600" alt="" @click="isDisplayBigPhoto = false">
    </div>
  </div>
</template>

<script>
import { MessageBox, Indicator } from 'mint-ui'
export default {
  name: 'DeletePhoto',
  data: function () {
    return {
      photos: [],
      currentPhotoIndex: 0,
      isDisplayBigPhoto: false,
      photoListPageId: 1, // 加载到了第几页照片
      photoListPageSize: 40,
      photoListTotalCount: 0,
      photoListLoading: false, // 照片列表是否在loading
    }
  },
  async created () {
    try {
      this.photoListLoading = true
      const currentUserId = (await this.$faApi.isLogin()).userId
      const getPhotoRes = await this.$faApi.getAlbumPhotos({
        groupId: this.$route.params.groupId, 
        albumId: this.$route.params.albumId,
        pageSize: this.photoListPageSize,
        pageId: this.photoListPageId
      })
      const allPhotos = getPhotoRes.data
      this.photoListTotalCount = getPhotoRes.totalCount
      this.photoListLoading = false
      this.photos = allPhotos.filter(photo => photo.uploader.id === currentUserId)
    } catch (err) {
      this.$faLogger.error('DeletePhoto.vue:created', err)
    }
  },
  methods: {
    async delPhoto(photoId) {
      try {
        const userChoice = await MessageBox({
          message: '确定删除吗?',
          showCancelButton: true
        })
        if (userChoice === 'confirm') {
          await this.$faApi.delPhoto(
            this.$route.params.groupId, 
            this.$route.params.albumId,
            photoId
          )
          this.photos = this.photos.filter(photo => photo.id !== photoId)
        }
      } catch (err) {
        this.$faLogger.error('DeletePhoto.vue:delPhoto', err)
      }
    },
    showBigPhoto(photoIndex) {
      this.currentPhotoIndex = photoIndex
      this.isDisplayBigPhoto = true
    },
    async loadMorePhoto() {
      if (this.photoListPageSize * this.photoListPageId < this.photoListTotalCount) {
        Indicator.open()
        this.photoListLoading = true
        this.photoListPageId += 1
        const newPhotos = (await this.$faApi.getAlbumPhotos({
          groupId: this.$route.params.groupId, 
          albumId: this.$route.params.albumId,
          pageSize: this.photoListPageSize,
          pageId: this.photoListPageId
        })).data
        this.photos = this.photos.concat(newPhotos)
        Indicator.close()
        this.photoListLoading = false
      }
    },
    goToAlbumHome() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/album/${this.$route.params.albumId}` })
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    height: 100%;
    .big_photo {
      width: 100%;
      height: 100%;
      display: flex;
      background-color: #000;
      z-index: 100000;
      position: absolute;
      align-items: center;
      img {
        width: 100%;
      }
    }
  }
  .navbar_box_fixed {
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #e0e0e0;
    background-color: white;
  }
  .navbar_box_width {
    position: relative;
    width: 100%;
    height: 48px;
  }
  .navbar_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    .back_btn {
      font-size: 14px;
      position: absolute;
      top: 14px;
      left: 10px;
    }
    .upload_input {
      display: none;
    }
  }
  .page_title {
    padding: 0 16px;
    line-height: 48px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 800;
    color: black;
  }
  .on_bar_center_absolute {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 48px;
    right: 48px;
  }
  .bar_done_btn {
    position: relative;
    float: right;
    margin: 8px;
    padding: 0 8px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
    font-weight: normal;
    color: red;
    cursor: pointer;
  }
  .photo_collection {
    position: relative;
    padding: 1px;
    padding-top: 49px;
    height: 100%;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .photo_box_width {
    position: relative;
    float: left;
    width: 33.33%;
  }
  .photo_box_padding {
    padding: 1px;
  }
  .photo_box_ratio {
    position: relative;
    width: auto;
    padding-top: 100%;
  }
  .photo_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    .upload_status {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: hsla(0,0%,0%,0.5);
      span {
        position: absolute;
        top: 50%;
        width: 100%;
        height: 32px;
        line-height: 32px;
        margin-top: -16px;
        font-size: 16px;
        font-weight: 900;
        text-align: center;
        color: white;
      }
    }
    .btn_del {
      position: absolute;
      left: 0;
      top: 0;
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url('../assets/btn_del_minus.png');
      cursor: pointer;
    }
  }
  .photo_image {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit:cover;
    background-color: #f5f5f5;
  }
  @media (max-width: 374px) {
    .photo_box_width { width: 33.33%; }
  }
  @media (min-width: 375px) and (max-width: 599px) {
    .photo_box_width { width: 33.33%; }
  }
  @media (min-width: 600px) and (max-width: 767px) {
    .photo_box_width { width: 25%; }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    .photo_box_width { width: 20%; }
  }
  @media (min-width: 1024px) and (max-width: 1159px) {
    .photo_box_width { width: 16.66%; }
  }
  @media (min-width: 1160px) and (max-width: 1679px) {
    .photo_box_width { width: 12.5%; }
  }
  @media (min-width: 1680px) {
    .photo_box_width { width: 10%; }
  }
</style>
  